import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ButtonGroup } from '@atlaskit/button';
import { nonEmptyList, PrimaryCTA } from '@atlassian/amkt-common';
import { ButtonClickedEvent, withAnalytics } from '@atlassian/mpac-analytics';
import { WindowUtils } from '@atlassian/mpac-utils';
import { Option } from 'funfix-core';
import React, { PureComponent } from 'react';
import { ANALYTICS_SUBJECT_ID_LEARN_MORE } from '../../../../analytics/Events';
import CancelButton from '../common/CancelButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class DialogInstructionalFooterBase extends PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "onClickLearnMore", learnMoreLink => () => {
      this.props.fireAnalyticsEvent({
        eventType: ButtonClickedEvent,
        actionSubjectId: ANALYTICS_SUBJECT_ID_LEARN_MORE,
        objectType: 'key',
        objectId: this.props.instructionalApp.details.key
      });
      WindowUtils.openPage(learnMoreLink, "".concat(this.props.instructionalApp.details.key, "-learnMore"));
    });
    _defineProperty(this, "render", () => Option.map2(nonEmptyList(this.props.instructionalApp.steps), Option.of(this.props.instructionalApp.learnMoreLink), (_, learnMoreLink) => /*#__PURE__*/_jsxs(ButtonGroup, {
      children: [/*#__PURE__*/_jsx(PrimaryCTA, {
        onClick: this.onClickLearnMore(learnMoreLink),
        children: "Learn more"
      }), /*#__PURE__*/_jsx(CancelButton, {
        isDisabled: false,
        onClick: this.props.closeInstallDialog,
        children: "Cancel"
      })]
    })).getOrElseL(() => /*#__PURE__*/_jsx(PrimaryCTA, {
      onClick: this.props.closeInstallDialog,
      children: "Done"
    })));
  }
}
export default withAnalytics(DialogInstructionalFooterBase);